/** Возвращает для мнемоники VAS бекенда мнемонику VAS на фп */
export const getNormalizedOptionName = (serviceTypes) => {
  const name = serviceTypes.join('');

  const map = {
    'Top3': 'top3',
    'PremiumObject': 'premium',
    'PremiumObjectHighlight': 'premium+highlight',
    'DebitObject': 'paid',
    'FreeObject': 'free',
  };

  return map[name];
};
